import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default, { useContext } from 'react';
import styled from 'styled-components';
import AnimateHeight from '../../../node_modules/react-animate-height/lib/AnimateHeight.js';
import { CollapseContext } from './CollapseContext.js';
import { Box } from '../box/Box.js';

var StyledBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "CollapsePanel__StyledBox",
  componentId: "sc-y8qg3l-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-height: ", ";\n  overflow-y: ", ";\n"], ["\n  max-height: ", ";\n  overflow-y: ", ";\n"])), function (_a) {
  var maxHeight = _a.maxHeight;
  return maxHeight ? "".concat(maxHeight, "px") : null;
}, function (_a) {
  var maxHeight = _a.maxHeight;
  return maxHeight ? "scroll" : "unset";
});
var CollapsePanel = function (_a) {
  var children = _a.children,
    maxHeight = _a.maxHeight,
    rest = __rest(_a, ["children", "maxHeight"]);
  var isOpen = useContext(CollapseContext).isOpen;
  return React__default.createElement(AnimateHeight, {
    height: isOpen ? "auto" : 0
  }, React__default.createElement(StyledBox, __assign({
    maxHeight: maxHeight,
    padding: 10
  }, rest), children));
};
var templateObject_1;

export { CollapsePanel };
//# sourceMappingURL=CollapsePanel.js.map
